import type { ExperimentalMutations } from '../__types__/ExperimentalMutations';
import { fetchJSON } from '../fetchJSON';
import { MediaType } from '../MediaType';

export const experimentalUpdateShortcutLinks: ExperimentalMutations['experimentalUpdateShortcutLinks'] =
	(_, args, { network }) =>
		fetchJSON(network, `/wiki/rest/ia/1.0/link/batch`, {
			method: 'POST',
			body: JSON.stringify(args),
			headers: {
				'Content-Type': MediaType.JSON,
			},
		});
